import angular from 'angular';
import ComponentsModule from '../../../components-module';
import template from './code-body.html';
import Debug from 'ace-ui/ace-debug';

const COMPONENT_NAME = 'codeBody';
const debug = new Debug (COMPONENT_NAME);

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,
    controller: ($scope, ApplicationConfigurationService, UiState) => {
      let ctrl = $scope.$ctrl;

      ctrl.lhsAsideEnabled = false;
      ctrl.rhsAsideEnabled = false;
      ctrl.lhsAsideUnfolded = true;
      ctrl.rhsAsideUnfolded = true;

      ctrl.toggleAside = (which) => {
        if (which === 'lhs') { ctrl.lhsAsideUnfolded = !ctrl.lhsAsideUnfolded; }
        if (which === 'rhs') { ctrl.rhsAsideUnfolded = !ctrl.rhsAsideUnfolded; }

        UiState.set(COMPONENT_NAME, {
          lhsAsideUnfolded: ctrl.lhsAsideUnfolded,
          rhsAsideUnfolded: ctrl.rhsAsideUnfolded
        });

      };

      ctrl.$onInit = () => {
        ApplicationConfigurationService.getConfigurationsFor(['ContentActivityInbox', 'WorkflowInbox', 'ContentStructure'])
          .then (([ contentActivityInbox, workflowInbox, contentStructure ]) => {
            debug.log ('conf read:', contentActivityInbox, workflowInbox, contentStructure);

            let defConf = { enabled: true };

            contentActivityInbox = Object.assign ({}, defConf, contentActivityInbox);
            workflowInbox = Object.assign ({}, defConf, workflowInbox);
            contentStructure = Object.assign ({}, defConf, contentStructure);

            if (!contentStructure.structureRoots || contentStructure.structureRoots.length <= 0) {
              contentStructure.enabled = false;
            }

            ctrl.lhsAsideEnabled = contentStructure.enabled;
            ctrl.rhsAsideEnabled = contentActivityInbox.enabled || workflowInbox.enabled;

            ctrl.lhsAsideUnfolded = UiState.get(COMPONENT_NAME, 'lhsAsideUnfolded');
            ctrl.rhsAsideUnfolded = UiState.get(COMPONENT_NAME, 'rhsAsideUnfolded');
          });
      };
    }
  });

export default COMPONENT_NAME;
